export const collapsible = {
    slots: {
        root: 'cursor-pointer',
    },
}
